import { render, staticRenderFns } from "./simple-layout-card.vue?vue&type=template&id=ea3ea100&scoped=true&"
import script from "./simple-layout-card.vue?vue&type=script&lang=js&"
export * from "./simple-layout-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3ea100",
  null
  
)

export default component.exports